import React, { useState, useEffect } from 'react'
import { Typography, Input, Row, Col, Button, Space, } from 'antd';
import { UserAddOutlined, SearchOutlined } from '@ant-design/icons';
import { Screen } from '../../components/UI/Screen.component';
import { Container } from '../../components/UI/Container.component';
import { ScreenHeader } from '../../components/UI/ScreenHeader.component';
import { Section } from '../../components/UI/Section.component';
import { Modal } from '../../components/UI/Modal/Modal.component';
import BranchService from '../../services/branch.service';
import { BranchTable } from '../../components/Dashboard/Branch/BranchTable';
import { AddNewBranchForm } from '../../components/Dashboard/Branch/AddNewBranchForm';
import { Billing } from '../../components/Dashboard/Billing/Billing';


const { Title } = Typography;


export const BillingScreen = () => {

    const DEFAULT_PAGE = 1;
    const DEFAULT_PAGE_SIZE = 100;
    const [pagination, setPagination] = useState({current: DEFAULT_PAGE, pageSize: DEFAULT_PAGE_SIZE});

    const [displayModal, setDisplayModal] = useState(false);
    const [search, setSearch] = useState('');
    const [dataSource, setDataSource] = useState([])
    const [isLoaded, setIsLoaded] = useState(false);
    const [change, setChange] = useState(false);

    const handleEnter = (e) => {
        if (e.key === 'Enter') {
            return false;
        }
    }

    useEffect(() => {
        let data = { limit: pagination.pageSize, page : pagination.current - 1, filter: search}
            BranchService.getBranches(data).then(
            (response) => {
                console.log(response)
                setDataSource(response.data.branches)
                setIsLoaded(true)
            },
            (error) => {
                console.log(error.response)
            }
        );
    }, [search, pagination.current, pagination.pageSize, change])


  
    


    const clearBtnDisplay = search === '' ? 'none' : 'block';

    return(
        <>
            <Screen id="access-screen">
                <Container>
                    <ScreenHeader style={{display: 'flex', justifyContent: 'center'}}>
                        <Title>Facturación</Title>
                    </ScreenHeader>
                    <Section>
                        { isLoaded && <Billing dataSource={dataSource}/>}
                    </Section>
                </Container>
                <Modal title='Agreagar Planta' visible={displayModal} setVisible={setDisplayModal} width={315} actionGroup={false}>
                    <AddNewBranchForm access={dataSource} setVisible={setDisplayModal} setChange={setChange} />
                </Modal>
            </Screen>
        </>
    )
}